
let personList = []
let departmentTree = []

let applyTypeList = []
let welfareList = []
let workTimeList = []
let posNoLIst = []

let dishSorts = [] // 菜品类别

let deviceAreaList = [] // 设备区域下拉列表
let deviceInstallSiteList = [] // 设备安装地点下拉列表
let deviceConsumeSiteList = [] // 设备消费地点下拉列表
let merchantTypeSorts = [] // 商户类型
let terminalTypeSorts = [] // 终端类型
let benefitsTypeSorts = [] // 福利类型
let dislimitTypeSorts = [] // 优惠限制类型
let bfuseageSorts = [] // 优惠开放时限类型
let personnelGroupSorts = [] // 人员分组
let accountTypeSorts = [] // 帐户类型
let rechargeTypeLists = [] // 充值类型（不含撤销）
let rechargeTypeSorts = [] // 充值类型
let peronAccountStatusSorts = [] // 人员/帐户状态
let accountDirectionSorts = [] // 记账方向
let exceptionalTypeSorts = [] // 异常类型
let exceptionalProcFlagSorts = [] // 异常处理标志
let tranTypeSorts = [] // 交易类型
let machineDealTypeSorts = [] // 终端交易类型
let incomeDealTypeSorts = [] // 收入明细表交易类型
let orderTypeSorts = [] // 支付类型
let orderPayFlagSorts = [] // 订单支付状态
let clearFlagSorts = [] // 销户结清状态
let refMethodSorts = [] // 销户结清方式

let feeTypeSorts = [] // 费用类型
let feePayMethod = [] // 费用支付方式
let saleChannelList = [] // 销售渠道下拉框

export default {
  deviceAreaList,
  deviceInstallSiteList,
  deviceConsumeSiteList,
  clearFlagSorts,
  refMethodSorts,
  personList,
  departmentTree,
  applyTypeList,
  workTimeList,
  posNoLIst,
  welfareList,
  rechargeTypeLists,
  rechargeTypeSorts,
  merchantTypeSorts,
  terminalTypeSorts,
  benefitsTypeSorts,
  dislimitTypeSorts,
  personnelGroupSorts,
  accountTypeSorts,
  bfuseageSorts,
  peronAccountStatusSorts,
  accountDirectionSorts,
  exceptionalTypeSorts,
  exceptionalProcFlagSorts,
  tranTypeSorts,
  dishSorts,
  machineDealTypeSorts,
  orderTypeSorts,
  orderPayFlagSorts,
  feeTypeSorts,
  feePayMethod,
  incomeDealTypeSorts,
  saleChannelList
}



// WEBPACK FOOTER //
// ./src/store/consume/state.js